import { ReactElement, useState, forwardRef } from "react";
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
  Typography,
} from "@mui/material";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { tokens } from "@/tokens";

export type TInputProps = {
  label?: string;
  required?: boolean;
  type: string;
  handleChangeValue: (val: string) => void;
  value?: string | number | null;
} & TextFieldProps;

const TextInput = forwardRef<HTMLInputElement, TInputProps>(({ 
  label,
  type,
  required,
  handleChangeValue,
  value,
  ...rest
}: TInputProps, ref): ReactElement => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const handleChange = (e: { target: { value: string } }) => {
    handleChangeValue(e.target.value);
  };

  return (
    <>
      {label && (
        <Typography
          sx={{ mb: 1, display: "flex", alignItems: "center", gap: 0.5 }}
          fontWeight={tokens.fontWeight.semibold}
          fontSize={tokens.fontSize.lg}
          variant="caption"
        >
          {label} {required && <Typography color={"error"}>*</Typography>}
        </Typography>
      )}
      {type === "password" && (
        <TextField
          {...rest}
          type={showPassword ? "text" : "password"}
          fullWidth
          value={value}
          onChange={handleChange}
          required={required}
          inputRef={ref}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? (
                    <FiEyeOff size={20} color="#AEAFB3" />
                  ) : (
                    <FiEye size={20} color="#AEAFB3" />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}

      {type !== "password" && (
        <TextField
          {...rest}
          type={type}
          fullWidth
          value={value}
          onChange={handleChange}
          required={required}
          inputRef={ref}
        />
      )}
    </>
  );
});

export default TextInput;
